import { Shield, Globe, Users, GraduationCap } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export const TrustBadges = () => {
  const { language, translations } = useLanguage();
  const t = translations?.trustBadges;

  const badges = [
    { icon: Shield, key: "neasc" as const },
    { icon: GraduationCap, key: "xunta" as const },
    { icon: Globe, key: "trilingual" as const },
    { icon: Users, key: "ages" as const },
  ];

  if (!t) return null;

  return (
    <section className="pt-20 pb-12 px-4 bg-card border-b border-border">
      <div className="container mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {badges.map((badge) => (
            <div
              key={badge.key}
              className="flex flex-col items-center text-center space-y-2"
            >
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                <badge.icon className="w-6 h-6 text-primary" />
              </div>
              <p className="text-sm font-medium text-foreground">
                {t[badge.key]}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
